<template>
  <div>
    <template v-if="data">
      <div class="font-weight-bold" pb-2>90 Days</div>
      <v-card>
        <v-layout row>
          <v-flex
            xs4
            :class="`${cardColorClass} lighten-4`"
            style="display: flex"
            align-center
            justify-center
          >
            <v-img src="/static/img/icon-gauge.png" height="150px" contain></v-img>
          </v-flex>
          <v-flex xs8 :class="`${cardColorClass}`">
            <v-card-title primary-title>
              <div>
                <div class="title pb-3">{{ data.msg_1 }}</div>
                <div class="body-1 pb-2">{{ data.msg_2 }}</div>
                <div class="body-1">{{ data.msg_3 }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      data: [],
      cardColorClass: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    await this.handleGetInitial()
  },
  methods: {
    async handleGetInitial() {
      const vm = this
      try {
        const response = await vm.getSummary3Months()
        if (response) {
          vm.data = response.data
          let currentStatus = response.data.msg_1
          vm.handleGetStatusColor(currentStatus)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getSummary3Months() {
      const vm = this
      let member_id = vm.$route && vm.$route.params.id
      let data = {
        page_id: vm.selectedBot.pageid
      }

      vm.loading = true
      const response = await nongtungjaiApi.getSummary3Months(
        {
          config: {
            params: data
          }
        },
        member_id
      )

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'ความเสี่ยงต่ำ':
            color = 'success'
            break
          case 'ความเสี่ยงปานกลาง':
            color = 'yellow'
            break
          case 'ความเสี่ยงสูง':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        this.cardColorClass = color
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/PatientSummaryCard.vue